"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getJwtTccProxy: ()=>getJwtTccProxy,
    defaultJwtConfig: ()=>defaultJwtConfig,
    getJwtConfig: ()=>getJwtConfig
});
const core_lib_namespaceObject = require("@bytecloud/core-lib");
const external_jwt_config_js_namespaceObject = require("./jwt.config.js");
const once_namespaceObject = require("lodash/once");
var once_default = /*#__PURE__*/ __webpack_require__.n(once_namespaceObject);
const query_config_js_namespaceObject = require("../utils/query.config.js");
const defaultJwtConfig = {
    domainIDToPartition: {
        local: 'cn-sandbox',
        sandbox: 'cn-sandbox',
        boe: 'cn-boe',
        online: 'cn',
        hl: 'cn-backup',
        lq: 'cn-backup',
        pd: 'cn-backup',
        'boe-i18n': 'cn',
        us: 'us',
        i18n: 'i18n',
        'i18n-sg': 'i18n-backup',
        'ttp-row': 'i18n',
        'ttp-row-sg': 'i18n-backup',
        'ttp-us': 'tx',
        'ttp-us-limited': 'tx-limited',
        tx: 'tx-limited',
        'tx-tt': 'tx-limited',
        sinf: 'sinf',
        sinfi18n: 'sinfi18n',
        'sinf-boe': 'sinf',
        'sinf-xfl': 'sinf',
        'sinf-xfl-boe': 'sinf',
        sinfonlinea: 'sinf',
        xfl: 'sinf',
        volcgroup: 'volcgroup',
        'volcgroup-boe': 'volcgroup',
        'ttp-eu': 'i18n',
        'ttp-eu-de': 'i18n-backup',
        'i18n-bd': 'i18n-bd',
        'i18n-bd-de': 'i18n-bd-backup'
    },
    partitionToUniqueKeys: {
        test: [
            'local-test'
        ],
        'cn-sandbox': [
            'sandbox',
            'online',
            'boe',
            'cn-byted',
            'cn-ttp-row',
            'cn-byteintl'
        ],
        'cn-boe': [
            'boe',
            'online',
            'cn-byted',
            'cn-ttp-row',
            'cn-byteintl'
        ],
        cn: [
            'online',
            'cn-byted',
            'cn-ttp-row',
            'cn-byteintl'
        ],
        'cn-backup': [
            'hl',
            'lq',
            'pd'
        ],
        us: [
            'us'
        ],
        i18n: [
            'ttp-row',
            'i18n',
            'i18n-byteintl',
            'ttp-row-org',
            'i18n-eu-net',
            'i18n-eu-org',
            'i18n-byted'
        ],
        'i18n-backup': [
            'i18n-sg',
            'ttp-row-sg'
        ],
        tx: [
            'ttp-us',
            'ttp-us-org'
        ],
        'tx-limited': [
            'ttp-us-limited',
            'ttp-us-row',
            'ttp-us-row-org'
        ],
        sinf: [
            'sinf',
            'sinfonlinea',
            'sinf-bytedance'
        ],
        sinfi18n: [
            'sinfi18n'
        ],
        volcgroup: [
            'volcgroup'
        ],
        'i18n-bd': [
            'i18n-bd'
        ],
        'i18n-bd-backup': [
            'i18n-bd-de'
        ]
    },
    jwtItems: {
        sandbox: external_jwt_config_js_namespaceObject.jwtItems.sandbox,
        online: external_jwt_config_js_namespaceObject.jwtItems.online,
        hl: external_jwt_config_js_namespaceObject.jwtItems.hl,
        lq: external_jwt_config_js_namespaceObject.jwtItems.lq,
        pd: external_jwt_config_js_namespaceObject.jwtItems.pd,
        boe: external_jwt_config_js_namespaceObject.jwtItems.boe,
        us: external_jwt_config_js_namespaceObject.jwtItems.us,
        i18n: external_jwt_config_js_namespaceObject.jwtItems.i18n,
        'i18n-sg': external_jwt_config_js_namespaceObject.jwtItems["i18n-sg"],
        'ttp-us-limited': external_jwt_config_js_namespaceObject.jwtItems["ttp-us-limited"],
        'ttp-us': external_jwt_config_js_namespaceObject.jwtItems["ttp-us"],
        sinf: external_jwt_config_js_namespaceObject.jwtItems.sinf,
        sinfi18n: external_jwt_config_js_namespaceObject.jwtItems.sinfi18n,
        sinfonlinea: external_jwt_config_js_namespaceObject.jwtItems.sinfonlinea,
        volcgroup: external_jwt_config_js_namespaceObject.jwtItems.volcgroup,
        'ttp-row': external_jwt_config_js_namespaceObject.jwtItems["ttp-row"],
        'ttp-row-sg': external_jwt_config_js_namespaceObject.jwtItems["ttp-row-sg"],
        'cn-byted': external_jwt_config_js_namespaceObject.jwtItems["cn-byted"],
        'i18n-byteintl': external_jwt_config_js_namespaceObject.jwtItems["i18n-byteintl"],
        'cn-ttp-row': external_jwt_config_js_namespaceObject.jwtItems["cn-ttp-row"],
        'ttp-row-org': external_jwt_config_js_namespaceObject.jwtItems["ttp-row-org"],
        'local-test': external_jwt_config_js_namespaceObject.jwtItems["local-test"],
        'sinf-bytedance': external_jwt_config_js_namespaceObject.jwtItems["sinf-bytedance"],
        'ttp-us-row': external_jwt_config_js_namespaceObject.jwtItems["ttp-us-row"],
        'cn-byteintl': external_jwt_config_js_namespaceObject.jwtItems["cn-byteintl"],
        'i18n-eu-net': external_jwt_config_js_namespaceObject.jwtItems["i18n-eu-net"],
        'i18n-eu-org': external_jwt_config_js_namespaceObject.jwtItems["i18n-eu-org"],
        'ttp-us-org': external_jwt_config_js_namespaceObject.jwtItems["ttp-us-org"],
        'ttp-us-row-org': external_jwt_config_js_namespaceObject.jwtItems["ttp-us-row-org"],
        'i18n-byted': external_jwt_config_js_namespaceObject.jwtItems["i18n-byted"],
        'i18n-bd': external_jwt_config_js_namespaceObject.jwtItems["i18n-bd"],
        'i18n-bd-de': external_jwt_config_js_namespaceObject.jwtItems["i18n-bd-de"],
        currentOrigin: {
            baseUrl: '/auth/api/v1',
            fetchTimeout: 8000
        }
    }
};
const getJwtTccProxy = once_default()(()=>{
    const isPreview = (0, query_config_js_namespaceObject.checkTccProxyFlag)('preview', 'jwt-config');
    const isTest = (0, query_config_js_namespaceObject.checkTccProxyFlag)('test', 'jwt-config');
    const instance = new core_lib_namespaceObject.TccProxy({
        namespace: 'bytecloud.fe.config',
        key: 'jwt',
        isPreview,
        isTest,
        defaultValue: defaultJwtConfig,
        hostname: 'undefined' != typeof location ? location.hostname : '',
        fetchStrategy: 'networkFirst',
        validator (value) {
            try {
                return Object.prototype.hasOwnProperty.call(value, 'jwtItems');
            } catch (error) {
                return false;
            }
        },
        useFallbackHostname: true
    });
    return {
        instance,
        isProd: !isPreview && !isTest
    };
});
const getJwtConfig = once_default()(async ()=>{
    const { instance: tccProxy } = getJwtTccProxy();
    const result = await tccProxy.getConfig() || defaultJwtConfig;
    try {
        Object.values(result.jwtItems).forEach((item)=>{
            if ('boolean' != typeof item.skipDowngradeCheck) item.skipDowngradeCheck = true;
        });
    } catch (error) {
        console.error(error);
    }
    return result;
});
exports.defaultJwtConfig = __webpack_exports__.defaultJwtConfig;
exports.getJwtConfig = __webpack_exports__.getJwtConfig;
exports.getJwtTccProxy = __webpack_exports__.getJwtTccProxy;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "defaultJwtConfig",
    "getJwtConfig",
    "getJwtTccProxy"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
